import React from "react";
import { Flex, Box } from "grid-styled";

import { Avatar, Measure, TextLink, Text, Heading } from "../globals";

const RecommendationListItem = ({ recommendation }) => {
    const { designer } = recommendation;
    const fullName = `${designer.firstName} ${designer.lastName}`;

    return (
        <Flex>
            <Box mr={4}>
                <Avatar src={designer.avatar} alt={``} />
            </Box>
            <Flex flexDirection="column">
                <div>
                    <Heading is="h4" fontSize={3} lineHeight="1.5">
                        {designer.websiteLink ? (
                            <TextLink
                                href={designer.websiteLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                fontWeight="bold"
                            >
                                {fullName}
                            </TextLink>
                        ) : (
                            fullName
                        )}
                        {designer.twitterUsername ? (
                            <span>&nbsp;&nbsp;</span>
                        ) : null}
                        {designer.twitterUsername ? (
                            <TextLink
                                href={`https://twitter.com/${
                                    designer.twitterUsername
                                }`}
                                target="_blank"
                                rel="noopener noreferrer"
                                fontWeight="normal"
                                shade="light"
                            >
                                {`@${designer.twitterUsername}`}
                            </TextLink>
                        ) : null}
                    </Heading>
                </div>
                <Text is="span" color="#3D3D3D">
                    {designer.title}
                </Text>
                <Box pt={4}>
                    {recommendation.reason.split("\n").map((paragraph, i) => {
                        return (
                            <Measure mt={i !== 0 ? 3 : 0} key={i} is="p">
                                {paragraph}
                            </Measure>
                        );
                    })}
                </Box>
            </Flex>
        </Flex>
    );
};

export default RecommendationListItem;



// WEBPACK FOOTER //
// ./src/components/RecommendationListItem/index.js